import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserFooter from '../components/UserFooter';
import '../styles/LegalPages.css';

const TermsOfService = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <img
          src="/assets/images/logo2.png"
          alt="LegacyStat"
          className="legal-logo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
        <div style={{ width: '24px' }}></div>
      </header>

      {/* Content */}
      <div className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-updated">Last Updated: February 2026</p>

          <section className="legal-section">
            <h2>Introduction</h2>
            <p>These Terms of Service ("Terms") govern your use of the LegacyStat Spotlight platform (the "Service").</p>
          </section>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or submitting content to the Service, you agree to these Terms.</p>
          </section>

          <section className="legal-section">
            <h2>2. Eligibility</h2>
            <p>All submissions must be made by an adult (18+), such as a parent, guardian, or coach.</p>
          </section>

          <section className="legal-section">
            <h2>3. Submissions & Content Ownership</h2>
            <p>By submitting an athlete, you confirm:</p>
            <ul>
              <li>You have the right to upload the media</li>
              <li>You grant LegacyStat a non-exclusive license to display the content</li>
              <li>You allow formatting adjustments (resizing/cropping)</li>
            </ul>
            <p>Ownership remains with the creator; LegacyStat only uses the content for Spotlight purposes.</p>
          </section>

          <section className="legal-section">
            <h2>4. Prohibited Content</h2>
            <p>You may not submit:</p>
            <ul>
              <li>Copyrighted media you do not own</li>
              <li>False athlete information</li>
              <li>Offensive or inappropriate content</li>
              <li>Submissions for minors without parental/guardian approval</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Spotlight Publishing</h2>
            <p>LegacyStat determines which athletes are selected. Publishing is not guaranteed.</p>
          </section>

          <section className="legal-section">
            <h2>6. Removal Requests</h2>
            <p>Parents, guardians, or athletes may request removal anytime.</p>
            <p>Contact: <a href="mailto:support@legacystat.com" className="legal-link">support@legacystat.com</a></p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>The Service is provided "as is." LegacyStat is not liable for errors, interruptions, or misuse.</p>
          </section>

          <section className="legal-section">
            <h2>8. Modifications to Service</h2>
            <p>We may change or discontinue parts of the Service without notice.</p>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>These Terms are governed by U.S. and California law.</p>
          </section>

          <section className="legal-section">
            <h2>10. Contact</h2>
            <p>Questions or concerns: <a href="mailto:support@legacystat.com" className="legal-link">support@legacystat.com</a></p>
          </section>
        </div>
      </div>

      <UserFooter />
    </div>
  );
};

export default TermsOfService;
